var CSS_BODY_OVERFLOW_CLASS = ['overflow-hidden', 'md:overflow-visible'];
var CSS_BODY_OPENED_CLASS = 'global-menu-menu--is-opened';
var CSS_HIDDEN_CLASS = 'hidden';
var CSS_SHOWN_CLASS = 'block';
var CSS_CONTENT_SHOWN_CLASSES = ['block', 'md:table'];
var JS_TRIGGER_SELECTOR = 'global-mega-menu__trigger';
var JS_CONTENT_SELECTOR = 'global-mega-menu__content';
var OPENED_ICON_SELECTOR = 'global-mega-menu__open';
var CLOSED_ICON_SELECTOR = 'global-mega-menu__close';
var bodyEl = null;
var openedIconEl = null;
var closedIconEl = null;
var contentEls = [];
var isOpen = false;
function show() {
    var _a;
    if (openedIconEl && closedIconEl) {
        openedIconEl.classList.add(CSS_HIDDEN_CLASS);
        openedIconEl.classList.remove(CSS_SHOWN_CLASS);
        closedIconEl.classList.remove(CSS_HIDDEN_CLASS);
        closedIconEl.classList.add(CSS_SHOWN_CLASS);
    }
    if (bodyEl) {
        (_a = bodyEl.classList).add.apply(_a, CSS_BODY_OVERFLOW_CLASS);
        bodyEl.classList.add(CSS_BODY_OPENED_CLASS);
    }
    contentEls.forEach(function (contentEl) {
        var _a;
        contentEl.classList.remove(CSS_HIDDEN_CLASS);
        (_a = contentEl.classList).add.apply(_a, CSS_CONTENT_SHOWN_CLASSES);
    });
    isOpen = true;
}
function hide() {
    var _a;
    if (openedIconEl && closedIconEl) {
        openedIconEl.classList.remove(CSS_HIDDEN_CLASS);
        openedIconEl.classList.add(CSS_SHOWN_CLASS);
        closedIconEl.classList.add(CSS_HIDDEN_CLASS);
        closedIconEl.classList.remove(CSS_SHOWN_CLASS);
    }
    if (bodyEl) {
        (_a = bodyEl.classList).remove.apply(_a, CSS_BODY_OVERFLOW_CLASS);
        bodyEl.classList.remove(CSS_BODY_OPENED_CLASS);
    }
    contentEls.forEach(function (contentEl) {
        var _a;
        (_a = contentEl.classList).remove.apply(_a, CSS_CONTENT_SHOWN_CLASSES);
        contentEl.classList.add(CSS_HIDDEN_CLASS);
    });
    isOpen = false;
}
function handleClick(evt) {
    evt.preventDefault();
    if (isOpen) {
        hide();
    }
    else {
        show();
    }
    return false;
}
export function globalMegaMenuInit() {
    bodyEl = document.querySelector('body');
    var triggers = Array.from(document.querySelectorAll("[data-js-selector='".concat(JS_TRIGGER_SELECTOR, "']")));
    triggers.forEach(function (trigger) {
        trigger.addEventListener('click', handleClick);
    });
    contentEls = Array.from(document.querySelectorAll("[data-js-selector='".concat(JS_CONTENT_SELECTOR, "']")));
    openedIconEl = document.querySelector("[data-js-selector='".concat(OPENED_ICON_SELECTOR, "']"));
    closedIconEl = document.querySelector("[data-js-selector='".concat(CLOSED_ICON_SELECTOR, "']"));
}
